import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './TopNavBar.module.css';

const TopNavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef();
  const location = useLocation(); // <-- this gets the current page

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    };
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={styles.topNav}>
      <div className={styles.logo}>MarsReacts</div>

      <button
        className={styles.menuButton}
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
      >
        ☰
      </button>

      <ul className={styles.navLinksDesktop}>
        <li><Link to="/" className={isActive('/') ? styles.activeLink : ''}>Home</Link></li>
        <li><Link to="/features" className={isActive('/features') ? styles.activeLink : ''}>Features</Link></li>
        <li><Link to="/pricing" className={isActive('/pricing') ? styles.activeLink : ''}>Pricing</Link></li>
        <li><Link to="/contact" className={isActive('/contact') ? styles.activeLink : ''}>Contact</Link></li>
      </ul>

      {/** Mobile drawer */}
      <div
        className={`${styles.drawer} ${menuOpen ? styles.showDrawer : ''}`}
        ref={menuRef}
      >
        <ul className={styles.drawerLinks}>
          <li><Link to="/" onClick={closeMenu} className={isActive('/') ? styles.activeLink : ''}>Home</Link></li>
          <li><Link to="/features" onClick={closeMenu} className={isActive('/features') ? styles.activeLink : ''}>Features</Link></li>
          <li><Link to="/pricing" onClick={closeMenu} className={isActive('/pricing') ? styles.activeLink : ''}>Pricing</Link></li>
          <li><Link to="/contact" onClick={closeMenu} className={isActive('/contact') ? styles.activeLink : ''}>Contact</Link></li>
        </ul>
      </div>

      {menuOpen && <div className={`${styles.overlay} ${styles.showOverlay}`} />}
    </nav>
  );
};

export default TopNavBar;
